import Vue from "vue";
import { MUTATION_TYPES } from "@/lib/const";
const { CLEAR_DATA } = MUTATION_TYPES;

export const clearStore = (storePath: string = "") => {
  return Vue.extend({
    beforeDestroy(): void {
      this.$store.commit(`${storePath}/${CLEAR_DATA}`);
    }
  });
};
